import script from "./FGReq.vue?vue&type=script&setup=true&lang=js"
export * from "./FGReq.vue?vue&type=script&setup=true&lang=js"

import "./FGReq.vue?vue&type=style&index=0&id=0d95f7b7&lang=css"

const __exports__ = script;

export default __exports__